-- uint32 words wrap the way machine words do, so their bit operations agree
-- with a GPU kernel's bit for bit. Each input word is xored with the mask.

local u32 = math.u32
local input = {0x00000000, 0x00ff00ff, 0x12345678, 0xffffffff}
local mask = u32.wrap(0xa5a5a5a5)

for index, value in ipairs(input) do
    print(('%d: 0x%08x'):format(index, u32.xorbits(u32.wrap(value), mask)))
end

-- try breaking it: give `u32.wrap` a non-integer, or change the mask and rerun
